<template>
  <div class="hello">
    <header>
      <img src="static/image/banner.png" alt="">
    </header>
    <section>
      <div class="select">
        <div>
          <img :src="item.img" alt="" v-for="item in headerImg" :key="item.img" @click="clickTap(item.title)" >
        </div>
        <div>
          <img :src="item.img" alt=""  v-for="item in headerImgTwo" :key="item.img"
          @click="clickTap(item.title)" >
        </div>
      </div>
      <List :objList="objList" />
      <p v-if="loadMore" @click="loadMores">加载更多></p>
    </section>

    <footer>
      <footerS :obj="footer" />
    </footer>
  </div>
</template>

<script>
import footerS from "./Footer.vue";
import List from "./List.vue";

export default {
  name: "HelloWorld",
  data() {
    return {
      headerImg: [
        {
          img: "static/image/t1.png",
          title: "全部"
        },
        {
          img: "static/image/t2.png",
          title: "设备制造"
        },
        {
          img: "static/image/t3.png",
          title: "矿业加工"
        },
        {
          img: "static/image/t4.png",
          title: "纺织制衣"
        }
      ],
      headerImgTwo: [
        {
          img: "static/image/t5.png",
          title: "瓷器家居"
        },
        {
          img: "static/image/t6.png",
          title: "教育医疗"
        },
        {
          img: "static/image/t7.png",
          title: "旅游景区"
        },
        {
          img: "static/image/t8.png",
          title: "其它"
        }
      ],
       list: [
        {
          img: "static/images/1.png",
          name: "中央党校",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=36729a7da015123205d408eec63fb34b",
          classificationOne: "教育医疗",
          classificationTwo: "教育医疗",
          classificationThree: "教育医疗"
        },
        {
          img: "static/images/2.png",
          name: "唐山奉岗灰业",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=dca3b334abb83aa189788e0745fc74eb",
          classificationOne: "矿业加工",
          classificationTwo: "矿业加工",
          classificationThree: "矿业加工"
        },
        {
          img: "static/images/3.png",
          name: "北京四中国际课程佳莲校区",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3f27792aac70d90f9a62df77585940fa",
          classificationOne: "教育医疗",
          classificationTwo: "学校教育",
          classificationThree: "中小学"
        },
        {
          img: "static/images/4.png",
          name: "河南洛阳新春都生物制药有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=ed9e3e6ad5d9f5ac044aa097ef97dd4f",
          classificationOne: "教育医疗",
          classificationTwo: "保健品",
          classificationThree: "保健品"
        },
        {
          img: "static/images/5.png",
          name: "江西维莱营健高科有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=c154996c1ca69375c5b93b67cdded491",
          classificationOne: "教育医疗",
          classificationTwo: "保健品",
          classificationThree: "保健品"
        },

        {
          img: "static/images/6.png",
          name: "广西北流三环企业集团",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=014a68e46bec627f900c716b653b9159",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/7.png",
          name: "河北光耀电缆有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=0c23f95713e1c0075a1b770d6f5d91ee",
          classificationOne: "设备制造",
          classificationTwo: "有线电缆",
          classificationThree: "有线电缆"
        },
        {
          img: "static/images/8.png",
          name: "山东英利实业有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=fb877a9d741e66646213f85955c90322",
          classificationOne: "设备制造",
          classificationTwo: "综合",
          classificationThree: "综合"
        },
        {
          img: "static/images/9.png",
          name: "成都美亚蒙特梭利幼儿园世纪城校区",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=4e4523154757c5f0faa675fec875b584",
          classificationOne: "教育医疗",
          classificationTwo: "幼儿园",
          classificationThree: "幼儿园"
        },
        {
          img: "static/images/10.png",
          name: "金洋铝业720VR全景观厂",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=db533121a8ce69c80216cd0859840adb",
          classificationOne: "矿业加工",
          classificationTwo: "铝金属冶炼",
          classificationThree: "铝金属冶炼"
        },
        {
          img: "static/images/11.png",
          name: "泉州有志石材有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=985f303c9be45cc5e453bfb73fa1e87a",
          classificationOne: "瓷器家居",
          classificationTwo: "石器",
          classificationThree: "石器"
        },
        {
          img: "static/images/12.png",
          name: "山东惠民欣航化纤制品有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=d0ab5303271d304a2a1187db7d7ebe6b",
          classificationOne: "设备制造",
          classificationTwo: "绳网",
          classificationThree: "绳网"
        },
        {
          img: "static/images/13.png",
          name: "江西海联控股有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=1a27f73c0c0a0a4e5bed51bb7eccd0d2",
          classificationOne: "教育医疗",
          classificationTwo: "保健品",
          classificationThree: "保健品"
        },
        {
          img: "static/images/14.png",
          name: "泰国风情之旅",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/9ee9ac2e00a6b665/",
          classificationOne: "旅游景区  ",
          classificationTwo: "旅游景区  ",
          classificationThree: "旅游景区  "
        },
        {
          img: "static/images/15.png",
          name: "魅力烟台",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/531085646b1bd5d4/",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
        {
          img: "static/images/16.png",
          name: "弥勒市",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b0f54af2708d9057f5c2b284d6b9475a",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"


        },
        {
          img: "static/images/19.png",
          name: "七步沟风景区",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=f8e7d9c6c38ebbe2b135609083e1c311",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
        {
          img: "static/images/20.png",
          name: "锦州东佑精工有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=7ae60045169fecbd61cba78efd8fd6d2",
          classificationOne: "设备制造",
          classificationTwo: "汽车配件",
          classificationThree: "汽车配件"
        },
        {
          img: "static/images/21.png",
          name: "江西中亚科技有限公司1",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=732cd679c4d58554e100ab35e8c95064",
          classificationOne: "教育医疗",
          classificationTwo: "保健品",
          classificationThree: "保健品"
        },
        {
          img: "static/images/22.png",
          name: "百色市必晟矿业有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=f02a642e1ace1d426c633ac4a7dd7b54",
          classificationOne: "矿业加工",
          classificationTwo: "矿业加工",
          classificationThree: "矿业加工"
        },
        {
          img: "static/images/23.png",
          name: "溧阳市飞跃机电有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=ca6f425839f9c8e0b92d1a57a9cee753",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
        {
          img: "static/images/24.png",
          name: "凤凰传媒VR全景展示",
          flag: "false",
          url: "https://www.yunjing720.com/index.php?s=tour/index/index&tid=62584a4f68a8b68b2cade39b746ef5af",
          classificationOne: "其它",
          classificationTwo: "地产",
          classificationThree: "地产"
     
    
        },

        {
          img: "static/images/28.png",
          name: "朔州市天力房地产开发有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=2d7b13b4a6b58e1070c62c3e5f198fe5",
          classificationOne: "其它",
          classificationTwo: "地产",
          classificationThree: "地产"
        },
        {
          img: "static/images/29.png",
          name: "潍坊鑫丰纺织有限公司",
          flag: "true",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=aa56635032af80d28d15133fee52e1db",
          classificationOne: "纺织制衣",
          classificationTwo: "纺织品",
          classificationThree: "纺织品"
        },
        {
          img: "static/images/30.png",
          name: "盱眙欧歌电子有限公司",
          flag: "true",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=b5e1df1e2189ce9af1ed6e59b4ecd2e9",
          classificationOne: "设备制造",
          classificationTwo: "电子电工",
          classificationThree: "电子电工"
        },
        {
          img: "static/images/31.png",
          name: "雍熙红木馆",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=9adc7b3f6b848c71bd08e8e1b074eacc",
          classificationOne: "瓷器家居",
          classificationTwo: "红木家具",
          classificationThree: "红木家具"
        },
        {
          img: "static/images/32.png",
          name: "衡橡科技股份有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=6827e02619b989fe1aa8d8e91e08f453",
          classificationOne: "设备制造 ",
          classificationTwo: "地产建材",
          classificationThree: "地产建材"
        },
        {
          img: "static/images/33.png",
          name: "大冶尖峰水泥有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=58866baec46d45f7d8a3565196fb87cb",
          classificationOne: "矿业加工",
          classificationTwo: "水泥制造",
          classificationThree: "水泥制造"
        },
        {
          img: "static/images/34.png",
          name: "山东科宇厨业有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=a2a08565bc39510be630278b205cab62",
          classificationOne: "设备制造",
          classificationTwo: "厨具",
          classificationThree: "厨具"
        },
        {
          img: "static/images/35.png",
          name: "派韵家具江苏有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=fca7f270dc979cdfe337fa68312dff67",
          classificationOne: "瓷器家居",
          classificationTwo: "家具",
          classificationThree: "家具"
        },
        {
          img: "static/images/36.png",
          name: "郑州洞林湖旅游发展有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=d9e4375a1566062ed62690f33d9b066e",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
        {
          img: "static/images/37.png",
          name: "江西同天乐科技有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=762e43027cb7b70f7ac1ff60aec01b5c",
          classificationOne: "教育医疗",
          classificationTwo: "教育医疗",
          classificationThree: "教育医疗"
        },
        {
          img: "static/images/38.png",
          name: "浙江港宏装饰科技有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5f2c8ddb38c8e8412eb794719978fc1b",
          classificationOne: "设备制造  ",
          classificationTwo: "设备制造  ",
          classificationThree: "设备制造  "
        },
        {
          img: "static/images/39.png",
          name: "哈尔滨聚丰汽车贸易有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=c2fcf2d6e593a3cab3a31c08f05590d7",
          classificationOne: "其它",
          classificationTwo: "汽车服务",
          classificationThree: "汽车服务"
        },
        {
          img: "static/images/40.png",
          name: "泰山酒业集团股份有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ea5afd75bcb8b5422c6d492cff8eda47",
          classificationOne: "其它",
          classificationTwo: "酒业",
          classificationThree: "酒业"
        },
        {
          img: "static/images/41.png",
          name: "保定金萨工艺品有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=efd74e9634425d523482a9eccc0ca5d6",
          classificationOne: "瓷器家居",
          classificationTwo: "工艺花",
          classificationThree: "工艺花"
        },
        {
          img: "static/images/42.png",
          name: "抚州市临川龙鑫生态养殖有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=1e2b5d4429eea9e2ff22fd39f002cf93",
          classificationOne: "其它",
          classificationTwo: " 生态农业",
          classificationThree: " 生态农业"
        },
        {
          img: "static/images/43.png",
          name: "浙江港港码头仓储有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=47981bfed5564dafb9ff3aa07861085f",
          classificationOne: "其它",
          classificationTwo: "汽车服务",
          classificationThree: "汽车服务"
        },
        {
          img: "static/images/44.png",
          name: "醴陵市天鑫瓷业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=1805522e1b19f3f78b85e5cca7d26af0",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/45.png",
          name: "宜春市长飞文具有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b449643c78acb4aa142418d41bb323d3",
          classificationOne: "瓷器家居",
          classificationTwo: "彩笔",
          classificationThree: "彩笔"
        },
        {
          img: "static/images/46.png",
          name: "醴陵市和兴瓷业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=0888624cba481028d0f2c4ba7a2aa571",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/47.png",
          name: "嘉兴威图进出口有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=dfc62b099ef804d53e73161207f4a74d",
          classificationOne: "纺织制衣",
          classificationTwo: "外贸服装",
          classificationThree: "外贸服装"
        },
        {
          img: "static/images/48.png",
          name: "惠州益润有机硅有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=47b046a1146ae1efbe07a275826c61ec",
          classificationOne: "矿业化工",
          classificationTwo: "矿业化工",
          classificationThree: "矿业化工"
        },
        {
          img: "static/images/49.png",
          name: "浙江永耀灯饰有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=60f312431d44f4b73ff4a0bb74f45166",
          classificationOne: "家居制造",
          classificationTwo: "灯饰",
          classificationThree: "灯饰"
        },
        {
          img: "static/images/50.png",
          name: "醴陵荣祥陶瓷有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3c9f234b4c5645ebd0edceed907fc726",
          classificationOne: "工艺品制作",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/51.png",
          name: "长沙海艺陶瓷有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=cb87005229b9026bbb3fd09577428418",
          classificationOne: "工艺品制作",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/52.png",
          name: "高阳县荣仪毯业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ddcc29687a2877c84c7110c12559227a",
          classificationOne: "纺织化工",
          classificationTwo: "织物",
          classificationThree: "织物"
        },
        {
          img: "static/images/53.png",
          name: "醴陵市正才陶瓷制造有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ccf5a413c18037f17ca18b930f91ccef",
          classificationOne: "工艺品制作",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/54.png",
          name: "厦门凯浦瑞电子科技有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=c5abf52df11fe5d87eba6df1750f8e93",
          classificationOne: "设备制造",
          classificationTwo: "按摩椅",
          classificationThree: "按摩椅"
        },
        {
          img: "static/images/55.png",
          name: "常州爱信机电有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9bcfa7e58bab1de2d5393965053d355d",
          classificationOne: "设备制造",
          classificationTwo: "焊机制造",
          classificationThree: "焊机制造"
        },
        {
          img: "static/images/56.png",
          name: "安徽华菱西厨装备股份有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=45e3584fee7685d8db53ab8935f9c7b7",
          classificationOne: "设备制造",
          classificationTwo: "厨房食品机械",
          classificationThree: "厨房食品机械"
        },
        {
          img: "static/images/57.png",
          name: "运隆塑业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=e98f77b200739efab58ec5f8fe8a9645",
          classificationOne: "设备制造",
          classificationTwo: "注塑模具",
          classificationThree: "注塑模具"
        },
        {
          img: "static/images/58.png",
          name: "醴陵新宜瓷业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=dd85f2b818c2420d1d4503f6cf508e78",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/59.png",
          name: "海兴一诺化工有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=96c6ae2b4c34c471912852f9868cd293",
          classificationOne: "矿业加工",
          classificationTwo: "化工原料",
          classificationThree: "化工原料"
        },
        {
          img: "static/images/60.png",
          name: "河北龙胜石制工艺品厂3D全景",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=910bb0ee2a3e3739de9f237f8bdee4d3",
          classificationOne: "矿业加工",
          classificationTwo: "石器",
          classificationThree: "石器"
        },
        {
          img: "static/images/61.png",
          name: "滁州韩上电器有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=4c5abe84d4e1bbb0d2b9412958906d4c",
          classificationOne: "设备制造",
          classificationTwo: "电器制造",
          classificationThree: "电器制造"
        },
        {
          img: "static/images/62.png",
          name: "临海市协成工艺品有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=8c4dc38ea53423a223b2e7deecbabad3",
          classificationOne: "纺织制衣",
          classificationTwo: "旗帜",
          classificationThree: "旗帜"
        },
        {
          img: "static/images/63.png",
          name: "河北业诚塑料制品有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=346234842418e727a176a602a60a221f",
          classificationOne: "矿业加工",
          classificationTwo: "注塑模具",
          classificationThree: "注塑模具"
        },
        {
          img: "static/images/64.png",
          name: "山东滨州红叶网业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=a0b8cc15a3a0b94322e0af0624536ef9",
          classificationOne: "设备制造",
          classificationTwo: " 绳具/安全网",
          classificationThree: " 绳具/安全网"
        },
        {
          img: "static/images/65.png",
          name: "黑旋风锯业股份有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=71e0c0b7998b260eae347a52fef7c4cc",
          classificationOne: "设备制造",
          classificationTwo: "五金锯片",
          classificationThree: "五金锯片"
        },
        {
          img: "static/images/66.png",
          name: "金华市金丰玩具有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3990b949d481095d57ce2aaff6412842",
          classificationOne: "设备制造",
          classificationTwo: "儿童玩具",
          classificationThree: "儿童玩具"
        },
        {
          img: "static/images/67.png",
          name: "广州妮希雅服装有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=f494806a8b8df46743c6ce51808c1a75",
          classificationOne: "纺织制衣",
          classificationTwo: "服装",
          classificationThree: "服装"
        },
        {
          img: "static/images/68.png",
          name: "任丘市华福盛通讯器材有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9c245c8ffa22e3a6be6d6c7d33da6b68",
          classificationOne: "设备制造",
          classificationTwo: "天线",
          classificationThree: "天线"
        },
        {
          img: "static/images/69.png",
          name: "新乐华宝医疗用品有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=8a2fee51e8ac23a1db6218a386839db6",
          classificationOne: "教育医疗",
          classificationTwo: "医疗器械 ",
          classificationThree: "医疗器械"
        },
        {
          img: "static/images/70.png",
          name: "上海裕生特种线材",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b459c7176891a2d28511813df7ed4edc",
          classificationOne: "设备制造",
          classificationTwo: "特种线材",
          classificationThree: "特种线材"
        },
        {
          img: "static/images/71.png",
          name: "宁波金盾电子工业股份有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=26ac35917159e2086a1ca1008126795a",
          classificationOne: "设备制造",
          classificationTwo: "报警器",
          classificationThree: "报警器"
        },
        {
          img: "static/images/72.png",
          name: "安徽红树林新材料科技有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=99a3096a45be0f60db87a5074ee61a42",
          classificationOne: "设备制造",
          classificationTwo: "塑木材料",
          classificationThree: "塑木材料"
        },
        {
          img: "static/images/73.png",
          name: "醴陵市瑞祥瓷业有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=2e1cc40153cd6649da6caf9eb19b259c",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器",
          classificationThree: "瓷器"
        },
        {
          img: "static/images/74.png",
          name: "宁波招宝山旅游风景区",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=761ea95a7a2db0072227281e51245f91",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
        {
          img: "static/images/75.png",
          name: "汕头市优品教育咨询有限公司 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=0742c09e7672d84d654dc3c5e8feb672",
          classificationOne: "教育医疗",
          classificationTwo: "幼儿园",
          classificationThree: "幼儿园"
        },
        {
          img: "static/images/76.png",
          name: "海宁爱生太阳能科技有限公司 ",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9f7c4846b6f3d45a658215edb28aa775",
          classificationOne: "设备制造",
          classificationTwo: "太阳能",
          classificationThree: "太阳能"
        },
        {
          img: "static/images/77.png",
          name: "2018华为北展联通大客户专场 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/tour/project/71434cddcad1cc7d/?from=singlemessage&isappinstalled=0",
          classificationOne: "其它",
          classificationTwo: "展会展厅",
          classificationThree: "展厅"
    

        },

        {
          img: "static/images/80.png",
          name: "中智合肥产业园管理有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=63eb1808775f39faeafd201c8ca87835",
          classificationOne: "其它",
          classificationTwo: "展会展厅",
          classificationThree: "展厅"
        },
        {
          img: "static/images/81.png",
          name: "安徽尊贵电器集团有限公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=17632075e71ee238649bc1d9118ae7d1",
          classificationOne: "设备制造",
          classificationTwo: "电器制造",
          classificationThree: "电器制造"
        },
        {
          img: "static/images/82.png",
          name: "三里屯home皇后饼屋",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=d9102a424056c3cbb8ba1c04f2d83528",
          classificationOne: "其它",
          classificationTwo: "餐饮娱乐",
          classificationThree: "餐饮娱乐"


        },
        {
          img: "static/images/85.png",
          name: "厦门大学VR全景",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/a3063c31e07e4a94/",
          classificationOne: "教育医疗",
          classificationTwo: "学校教育",
          classificationThree: "高校"

        },
        {
          img: "static/images/87.png",
          name: "瑞海姆田园度假村",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/310b967cc7b5ef77/",
          classificationOne: "其它",
          classificationTwo: "民宿",
          classificationThree: "民宿"



        },
        {
          img: "static/images/97.png",
          name: "福禄贝尔婚纱摄影",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/5b9d3b37539a3e84/",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器家居",
          classificationThree: "瓷器家居"


      
    

   
   
    

 
        },
        {
          img: "static/images/120.png",
          name: "北京汇诚鑫达汽车销售有限公司",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/9b8afec411c09ba1/",
          classificationOne: "其它",
          classificationTwo: "汽车服务",
          classificationThree: "汽车服务"
   



        },
        {
          img: "static/images/125.png",
          name: "国际教育展览会",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/eca0a5e0c6aa0d1d/",
          classificationOne: "其它",
          classificationTwo: "展会展厅",
          classificationThree: "线上会展"
        },
        {
          img: "static/images/126.png",
          name: "北京电子城IT产业园",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/b5f5bd6f11d77768/",
          classificationOne: "其它",
          classificationTwo: "机构园区",
          classificationThree: "机构园区"

  

     
        },
        {
          img: "static/images/131.png",
          name: "航天健康管理部",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/8c4f1a3487bb8987/",
          classificationOne: "教育医疗",
          classificationTwo: "医院",
          classificationThree: "医院"
  


        },
        {
          img: "static/images/135.png",
          name: "中国美术学院师生展",
          flag: "false",
          url: "https://www.yunjing720.com/tour/project/834f11bff2dca55f/",
          classificationOne: "其它",
          classificationTwo: "展会展厅",
          classificationThree: "美术馆"
   

        },
        {
          img: "static/images/138.png",
          name: "皓顺一号院",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=a5084b314e692089d7f23cba008f0a50",
          classificationOne: "瓷器家居",
          classificationTwo: "房地产",
          classificationThree: "房地产"

        },
        {
          img: "static/images/141.jpg",
          name: "河北五洲开元环保新材料有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=d2c02e3e578e50a04c864103bdf74cad",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
			{
          img: "static/images/142.jpg",
          name: "湖北省国土测绘院",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=da95afe0890b85f72ba7b7ebf799f288",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
		{
          img: "static/images/143.jpg",
          name: "泰州市远望换热设备有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3f0cbc1c7ce173f50a552f5ace478bcb",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
		{
          img: "static/images/144.jpg",
          name: "河北智达进出口有限责任公司",
          flag: "true",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=6aabf005de4b305d2bd5b0174d8cd007",
          classificationOne: "纺织制衣",
          classificationTwo: "纺织制衣",
          classificationThree: "纺织制衣"
        },
	                {
          img: "static/images/145.jpg",
          name: "华净科技(北京)有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=bf07372ac74cd9e5c0b1316bb902a3b0",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                              {
          img: "static/images/146.jpg",
          name: "华净科技(北京)有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=d99be1b0e3221d359a11f0f69f80f3ce",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                              {
          img: "static/images/147.jpg",
          name: "江门市金羚排气扇制造有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=7d211e0730c6de393fd5ca50a43187fe",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                              {
          img: "static/images/148.jpg",
          name: "江苏神彩印刷包装材料有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b3709637052a23bb2402dad0e9466865",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                               {
          img: "static/images/149.jpg",
          name: "湖南华日瓷业有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=fe69583e287bb89b37bd4a85d9348481",
          classificationOne: "瓷器家居",
          classificationTwo: "瓷器家居",
          classificationThree: "瓷器家居"
        },
                                   {
          img: "static/images/150.jpg",
          name: "广东森博科瑞莱空气制冷有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=2d56607b116126838a7bf08891ac9eae",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                    {
          img: "static/images/151.jpg",
          name: "南通市群泰纺织品有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=a7cc5ffb3f151dcb17aaf2350f764bd4",
          classificationOne: "纺织制衣",
          classificationTwo: "纺织制衣",
          classificationThree: "纺织制衣"
        },
                                      {
          img: "static/images/152.jpg",
          name: "邯郸曲周县中驰新材料有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=0e6edc2eba7b19e87d320d4e71105483",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                       {
          img: "static/images/153.jpg",
          name: "丹阳市裕桥精密元件有限公司   ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5bd2004eac0e7e01150a4b71c15b4432",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                        {
          img: "static/images/154.jpg",
          name: "江西百胜智能科技股份有限公司 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=77ef499c948800a04a21f5d1a10dab4b",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                       {
          img: "static/images/155.jpg",
          name: "雄县巨人纸塑包装有限公司 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=f49c2f4c75a16c114d7093ad511660c8",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                       {
          img: "static/images/156.jpg",
          name: "邢台北龙内燃机配件有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=453c5d1fbe68666aa6591c39f60b6535",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                       {
          img: "static/images/157.jpg",
          name: "迁安市旅游发展有限公司 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ca49d79bc39f594cff70d044f24af2f5",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
                                        {
          img: "static/images/158.jpg",
          name: "深圳市科路迪机械设备有限公司 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=1e995b12684ef2d95cd1e6e947509e68",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                        {
          img: "static/images/159.jpg",
          name: "平湖市巨龙儿童用品厂 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/i1ndex.php?s=tour/index/index&tid=794cc94b3707a226dea091b07800b11e",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                       {
          img: "static/images/160.jpg",
          name: "常州市太宇橡塑有限公司 ",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=cc5d62cd5a4ec1baede77cf07f8be222",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                        {
          img: "static/images/161.jpg",
          name: "河北众瑞环保设备有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=8d359ebfd10273a3ae866b145758b9a1",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                        {
          img: "static/images/162.jpg",
          name: "浙江中益机械有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5ac5b9d1ea1084113a96ea2713136a7c",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                       {
          img: "static/images/163.jpg",
          name: "浙江德易精密机械有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=6840a513400001860c289e8ae44cf3c2",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                      {
          img: "static/images/164.jpg",
          name: "怒江建浩农业科技发展有限责任公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=6ff4679a60422663a3d39954a2231c29",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                      {
          img: "static/images/165.jpg",
          name: "江门市三顺服饰有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=fefab254546f837db25a97fe200ceb2e",
          classificationOne: "纺织制衣",
          classificationTwo: "纺织制衣",
          classificationThree: "纺织制衣"
        },
                                      {
          img: "static/images/166.jpg",
          name: "贝特尔控股集团有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b56948256bde1de0601d96cbbee02e46",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                      {
          img: "static/images/167.jpg",
          name: "南昌梅岭旅游发展有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=9ff63622f93cc27dfc4c58a23e494b08",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
                                        {
          img: "static/images/168.jpg",
          name: "宁波依必艾轴承汽配实业有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=35d5332ee581959ca0b0b1665ba45551",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                       {
          img: "static/images/169.jpg",
          name: "北京信隆酒店物业管理有限公司上海分公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=fd1d380c053a975704cb108981d2b129",
          classificationOne: "旅游景区",
          classificationTwo: "旅游景区",
          classificationThree: "旅游景区"
        },
                                       {
          img: "static/images/170.jpg",
          name: "扬州华辉水泵有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=4e316446dd53b00d9ee56380ab3c4d49",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                        {
          img: "static/images/171.jpg",
          name: "河北省双牛建材有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=f28bfc9504fc9e16a209588a96feaad1",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                     {
          img: "static/images/172.jpg",
          name: "中国建筑材料工业建设西安工程有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=1tour/index/index&tid=81fdc061b83a5b67135555158a9bc4be",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                    {
          img: "static/images/173.jpg",
          name: "青州市北联工业有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3a53bd488983dd8920a70a59a09b638e",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                     {
          img: "static/images/174.jpg",
          name: "长沙市增华变压器有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=aa9e2e468141ebb9f26af4e2fd511a27",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                       {
          img: "static/images/175.jpg",
          name: "武汉凌云建筑装饰工程有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5f5f4913fefec8e965fc2728b1fc7ab7",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                       {
          img: "static/images/176.jpg",
          name: "海安山力机械科技有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9c57dcc5173f9759271b5bc19c2f7686",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                     {
          img: "static/images/177.jpg",
          name: "深圳市酩泉净水科技有限公司",
          flag: "false",
          url:
            "http://www.yunjing720.com/index.php?s=tour/index/index&tid=5c26ce802042102558f2ae30a0461a56",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                    {
          img: "static/images/178.jpg",
          name: "昆明顺弘新材料有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=504f7b153b7ea1744e97ffd6f8eec2a9",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                      {
          img: "static/images/179.jpg",
          name: "山东华骏钢结构工程有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=c71400dd1e0b12789a57df4974ba6940",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                     {
          img: "static/images/180.jpg",
          name: "江苏爱森思电气有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=6bd036dd82bdae00015336c29eb3ead6",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                      {
          img: "static/images/181.jpg",
          name: "江阴苏南国际集装箱码头有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=4006389728c1a15185212b46872d1fb1",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                     {
          img: "static/images/182.jpg",
          name: "唐山金亨通车料有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=0a157bd7219ab478cef42ab61b38d265",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                        {
          img: "static/images/183.png",
          name: "茅酱老酒文化（北京）有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=27ab17944778f7b3be12ceb6b0584b5a",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                      {
          img: "static/images/184.jpg",
          name: "沧州市三庆工贸有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5e4e59bce9e299fed95ec0bb85336b31",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                      {
          img: "static/images/185.jpg",
          name: "上海素茗实业有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=e8f6f1bc362906eacae1b8de709feadb",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                   {
          img: "static/images/186.jpg",
          name: "河北伊丽梦卫浴玻璃有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=61b67335fe40f4f12b3d3eb899eb4108",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },
                                   {
          img: "static/images/187.jpg",
          name: "北京汇丰华通光电科技有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=92cbdad68b2ea2aa26cf5a4c4a27f048",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                 {
          img: "static/images/188.jpg",
          name: "上海觅淘机电科技有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5999aa4d23638eb68678f8a0d9345880",
          classificationOne: "设备制造",
          classificationTwo: "设备制造",
          classificationThree: "设备制造"
        },
                                    {
          img: "static/images/189.jpg",
          name: "江苏吉莱微电子股份有限公司",
          flag: "false",
          url:
            "https://www.yunjing720.com/index.php?s=tour/index/index&tid=20c43d332096d473a5ebedb0f8f7b381",
          classificationOne: "其它",
          classificationTwo: "其它",
          classificationThree: "其它"
        },

      ],
      // list: [
      //   {
      //     img: "static/images/1.png",
      //     name: "中央党校",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=36729a7da015123205d408eec63fb34b",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "教育医疗",
      //     classificationThree: "教育医疗"
      //   },
      //   {
      //     img: "static/images/2.png",
      //     name: "唐山奉岗灰业",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=dca3b334abb83aa189788e0745fc74eb",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "矿业加工",
      //     classificationThree: "矿业加工"
      //   },
      //   {
      //     img: "static/images/3.png",
      //     name: "北京四中国际课程佳莲校区",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3f27792aac70d90f9a62df77585940fa",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "中小学"
      //   },
      //   {
      //     img: "static/images/4.png",
      //     name: "河南洛阳新春都生物制药有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=ed9e3e6ad5d9f5ac044aa097ef97dd4f",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "保健品",
      //     classificationThree: "保健品"
      //   },
      //   {
      //     img: "static/images/5.png",
      //     name: "江西维莱营健高科有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=c154996c1ca69375c5b93b67cdded491",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "保健品",
      //     classificationThree: "保健品"
      //   },

      //   {
      //     img: "static/images/6.png",
      //     name: "广西北流三环企业集团",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=014a68e46bec627f900c716b653b9159",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/7.png",
      //     name: "河北光耀电缆有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=0c23f95713e1c0075a1b770d6f5d91ee",
      //     classificationOne: "设备制造",
      //     classificationTwo: "有线电缆",
      //     classificationThree: "有线电缆"
      //   },
      //   {
      //     img: "static/images/8.png",
      //     name: "山东英利实业有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=fb877a9d741e66646213f85955c90322",
      //     classificationOne: "设备制造",
      //     classificationTwo: "综合",
      //     classificationThree: "综合"
      //   },
      //   {
      //     img: "static/images/9.png",
      //     name: "成都美亚蒙特梭利幼儿园世纪城校区",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=4e4523154757c5f0faa675fec875b584",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "幼儿园",
      //     classificationThree: "幼儿园"
      //   },
      //   {
      //     img: "static/images/10.png",
      //     name: "金洋铝业720VR全景观厂",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=db533121a8ce69c80216cd0859840adb",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "铝金属冶炼",
      //     classificationThree: "铝金属冶炼"
      //   },
      //   {
      //     img: "static/images/11.png",
      //     name: "泉州有志石材有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=985f303c9be45cc5e453bfb73fa1e87a",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "石器",
      //     classificationThree: "石器"
      //   },
      //   {
      //     img: "static/images/12.png",
      //     name: "山东惠民欣航化纤制品有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=d0ab5303271d304a2a1187db7d7ebe6b",
      //     classificationOne: "设备制造",
      //     classificationTwo: "绳网",
      //     classificationThree: "绳网"
      //   },
      //   {
      //     img: "static/images/13.png",
      //     name: "江西海联控股有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=1a27f73c0c0a0a4e5bed51bb7eccd0d2",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "保健品",
      //     classificationThree: "保健品"
      //   },
      //   {
      //     img: "static/images/14.png",
      //     name: "泰国风情之旅",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/9ee9ac2e00a6b665/",
      //     classificationOne: "旅游景区  ",
      //     classificationTwo: "旅游景区  ",
      //     classificationThree: "旅游景区  "
      //   },
      //   {
      //     img: "static/images/15.png",
      //     name: "魅力烟台",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/531085646b1bd5d4/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/16.png",
      //     name: "弥勒市",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b0f54af2708d9057f5c2b284d6b9475a",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/17.png",
      //     name: "重庆渝中智慧城市",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/a9a7f8d9e8ecf2d9/",
      //     classificationOne: "旅游景区  ",
      //     classificationTwo: "旅游景区  ",
      //     classificationThree: "旅游景区  "
      //   },
      //   {
      //     img: "static/images/18.png",
      //     name: "浣花酒店",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/62908f5b59ea2a26/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/19.png",
      //     name: "七步沟风景区",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=f8e7d9c6c38ebbe2b135609083e1c311",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/20.png",
      //     name: "锦州东佑精工有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=7ae60045169fecbd61cba78efd8fd6d2",
      //     classificationOne: "设备制造",
      //     classificationTwo: "汽车配件",
      //     classificationThree: "汽车配件"
      //   },
      //   {
      //     img: "static/images/21.png",
      //     name: "江西中亚科技有限公司1",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=732cd679c4d58554e100ab35e8c95064",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "保健品",
      //     classificationThree: "保健品"
      //   },
      //   {
      //     img: "static/images/22.png",
      //     name: "百色市必晟矿业有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=f02a642e1ace1d426c633ac4a7dd7b54",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "矿业加工",
      //     classificationThree: "矿业加工"
      //   },
      //   {
      //     img: "static/images/23.png",
      //     name: "溧阳市飞跃机电有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=ca6f425839f9c8e0b92d1a57a9cee753",
      //     classificationOne: "设备制造",
      //     classificationTwo: "设备制造",
      //     classificationThree: "设备制造"
      //   },
      //   {
      //     img: "static/images/24.png",
      //     name: "凤凰传媒VR全景展示",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/3fa0ff6b7e8e5d82/",
      //     classificationOne: "其它",
      //     classificationTwo: "地产",
      //     classificationThree: "地产"
      //   },
      //   {
      //     img: "static/images/25.png",
      //     name: "华能贵诚信托",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/2d705edb7c883021/",
      //     classificationOne: "其它 ",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/26.png",
      //     name: "首创热力",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b1c70c32a4265d66/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/27.png",
      //     name: "恒大绿洲",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/4bfaf92dd8c45d50/",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "地产",
      //     classificationThree: "地产"
      //   },

      //   {
      //     img: "static/images/28.png",
      //     name: "朔州市天力房地产开发有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=2d7b13b4a6b58e1070c62c3e5f198fe5",
      //     classificationOne: "其它",
      //     classificationTwo: "地产",
      //     classificationThree: "地产"
      //   },
      //   {
      //     img: "static/images/29.png",
      //     name: "潍坊鑫丰纺织有限公司",
      //     flag: "true",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=aa56635032af80d28d15133fee52e1db",
      //     classificationOne: "纺织制衣",
      //     classificationTwo: "纺织品",
      //     classificationThree: "纺织品"
      //   },
      //   {
      //     img: "static/images/30.png",
      //     name: "盱眙欧歌电子有限公司",
      //     flag: "true",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=b5e1df1e2189ce9af1ed6e59b4ecd2e9",
      //     classificationOne: "设备制造",
      //     classificationTwo: "电子电工",
      //     classificationThree: "电子电工"
      //   },
      //   {
      //     img: "static/images/31.png",
      //     name: "雍熙红木馆",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=9adc7b3f6b848c71bd08e8e1b074eacc",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "红木家具",
      //     classificationThree: "红木家具"
      //   },
      //   {
      //     img: "static/images/32.png",
      //     name: "衡橡科技股份有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=6827e02619b989fe1aa8d8e91e08f453",
      //     classificationOne: "设备制造 ",
      //     classificationTwo: "地产建材",
      //     classificationThree: "地产建材"
      //   },
      //   {
      //     img: "static/images/33.png",
      //     name: "大冶尖峰水泥有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=58866baec46d45f7d8a3565196fb87cb",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "水泥制造",
      //     classificationThree: "水泥制造"
      //   },
      //   {
      //     img: "static/images/34.png",
      //     name: "山东科宇厨业有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=a2a08565bc39510be630278b205cab62",
      //     classificationOne: "设备制造",
      //     classificationTwo: "厨具",
      //     classificationThree: "厨具"
      //   },
      //   {
      //     img: "static/images/35.png",
      //     name: "派韵家具江苏有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=fca7f270dc979cdfe337fa68312dff67",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "家具",
      //     classificationThree: "家具"
      //   },
      //   {
      //     img: "static/images/36.png",
      //     name: "郑州洞林湖旅游发展有限公司",
      //     flag: "false",
      //     url:
      //       "http://www.yunjing720.com/index.php?s=tour/index/index&tid=d9e4375a1566062ed62690f33d9b066e",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/37.png",
      //     name: "江西同天乐科技有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=762e43027cb7b70f7ac1ff60aec01b5c",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "教育医疗",
      //     classificationThree: "教育医疗"
      //   },
      //   {
      //     img: "static/images/38.png",
      //     name: "浙江港宏装饰科技有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=5f2c8ddb38c8e8412eb794719978fc1b",
      //     classificationOne: "设备制造  ",
      //     classificationTwo: "设备制造  ",
      //     classificationThree: "设备制造  "
      //   },
      //   {
      //     img: "static/images/39.png",
      //     name: "哈尔滨聚丰汽车贸易有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=c2fcf2d6e593a3cab3a31c08f05590d7",
      //     classificationOne: "其它",
      //     classificationTwo: "汽车服务",
      //     classificationThree: "汽车服务"
      //   },
      //   {
      //     img: "static/images/40.png",
      //     name: "泰山酒业集团股份有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ea5afd75bcb8b5422c6d492cff8eda47",
      //     classificationOne: "其它",
      //     classificationTwo: "酒业",
      //     classificationThree: "酒业"
      //   },
      //   {
      //     img: "static/images/41.png",
      //     name: "保定金萨工艺品有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=efd74e9634425d523482a9eccc0ca5d6",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "工艺花",
      //     classificationThree: "工艺花"
      //   },
      //   {
      //     img: "static/images/42.png",
      //     name: "抚州市临川龙鑫生态养殖有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=1e2b5d4429eea9e2ff22fd39f002cf93",
      //     classificationOne: "其它",
      //     classificationTwo: " 生态农业",
      //     classificationThree: " 生态农业"
      //   },
      //   {
      //     img: "static/images/43.png",
      //     name: "浙江港港码头仓储有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=47981bfed5564dafb9ff3aa07861085f",
      //     classificationOne: "其它",
      //     classificationTwo: "汽车服务",
      //     classificationThree: "汽车服务"
      //   },
      //   {
      //     img: "static/images/44.png",
      //     name: "醴陵市天鑫瓷业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=1805522e1b19f3f78b85e5cca7d26af0",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/45.png",
      //     name: "宜春市长飞文具有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b449643c78acb4aa142418d41bb323d3",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "彩笔",
      //     classificationThree: "彩笔"
      //   },
      //   {
      //     img: "static/images/46.png",
      //     name: "醴陵市和兴瓷业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=0888624cba481028d0f2c4ba7a2aa571",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/47.png",
      //     name: "嘉兴威图进出口有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=dfc62b099ef804d53e73161207f4a74d",
      //     classificationOne: "纺织制衣",
      //     classificationTwo: "外贸服装",
      //     classificationThree: "外贸服装"
      //   },
      //   {
      //     img: "static/images/48.png",
      //     name: "惠州益润有机硅有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=47b046a1146ae1efbe07a275826c61ec",
      //     classificationOne: "矿业化工",
      //     classificationTwo: "矿业化工",
      //     classificationThree: "矿业化工"
      //   },
      //   {
      //     img: "static/images/49.png",
      //     name: "浙江永耀灯饰有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=60f312431d44f4b73ff4a0bb74f45166",
      //     classificationOne: "家居制造",
      //     classificationTwo: "灯饰",
      //     classificationThree: "灯饰"
      //   },
      //   {
      //     img: "static/images/50.png",
      //     name: "醴陵荣祥陶瓷有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3c9f234b4c5645ebd0edceed907fc726",
      //     classificationOne: "工艺品制作",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/51.png",
      //     name: "长沙海艺陶瓷有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=cb87005229b9026bbb3fd09577428418",
      //     classificationOne: "工艺品制作",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/52.png",
      //     name: "高阳县荣仪毯业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ddcc29687a2877c84c7110c12559227a",
      //     classificationOne: "纺织化工",
      //     classificationTwo: "织物",
      //     classificationThree: "织物"
      //   },
      //   {
      //     img: "static/images/53.png",
      //     name: "醴陵市正才陶瓷制造有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=ccf5a413c18037f17ca18b930f91ccef",
      //     classificationOne: "工艺品制作",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/54.png",
      //     name: "厦门凯浦瑞电子科技有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=c5abf52df11fe5d87eba6df1750f8e93",
      //     classificationOne: "设备制造",
      //     classificationTwo: "按摩椅",
      //     classificationThree: "按摩椅"
      //   },
      //   {
      //     img: "static/images/55.png",
      //     name: "常州爱信机电有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9bcfa7e58bab1de2d5393965053d355d",
      //     classificationOne: "设备制造",
      //     classificationTwo: "焊机制造",
      //     classificationThree: "焊机制造"
      //   },
      //   {
      //     img: "static/images/56.png",
      //     name: "安徽华菱西厨装备股份有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=45e3584fee7685d8db53ab8935f9c7b7",
      //     classificationOne: "设备制造",
      //     classificationTwo: "厨房食品机械",
      //     classificationThree: "厨房食品机械"
      //   },
      //   {
      //     img: "static/images/57.png",
      //     name: "运隆塑业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=e98f77b200739efab58ec5f8fe8a9645",
      //     classificationOne: "设备制造",
      //     classificationTwo: "注塑模具",
      //     classificationThree: "注塑模具"
      //   },
      //   {
      //     img: "static/images/58.png",
      //     name: "醴陵新宜瓷业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=dd85f2b818c2420d1d4503f6cf508e78",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/59.png",
      //     name: "海兴一诺化工有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=96c6ae2b4c34c471912852f9868cd293",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "化工原料",
      //     classificationThree: "化工原料"
      //   },
      //   {
      //     img: "static/images/60.png",
      //     name: "河北龙胜石制工艺品厂3D全景",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=910bb0ee2a3e3739de9f237f8bdee4d3",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "石器",
      //     classificationThree: "石器"
      //   },
      //   {
      //     img: "static/images/61.png",
      //     name: "滁州韩上电器有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=4c5abe84d4e1bbb0d2b9412958906d4c",
      //     classificationOne: "设备制造",
      //     classificationTwo: "电器制造",
      //     classificationThree: "电器制造"
      //   },
      //   {
      //     img: "static/images/62.png",
      //     name: "临海市协成工艺品有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=8c4dc38ea53423a223b2e7deecbabad3",
      //     classificationOne: "纺织制衣",
      //     classificationTwo: "旗帜",
      //     classificationThree: "旗帜"
      //   },
      //   {
      //     img: "static/images/63.png",
      //     name: "河北业诚塑料制品有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=346234842418e727a176a602a60a221f",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "注塑模具",
      //     classificationThree: "注塑模具"
      //   },
      //   {
      //     img: "static/images/64.png",
      //     name: "山东滨州红叶网业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=a0b8cc15a3a0b94322e0af0624536ef9",
      //     classificationOne: "设备制造",
      //     classificationTwo: " 绳具/安全网",
      //     classificationThree: " 绳具/安全网"
      //   },
      //   {
      //     img: "static/images/65.png",
      //     name: "黑旋风锯业股份有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=71e0c0b7998b260eae347a52fef7c4cc",
      //     classificationOne: "设备制造",
      //     classificationTwo: "五金锯片",
      //     classificationThree: "五金锯片"
      //   },
      //   {
      //     img: "static/images/66.png",
      //     name: "金华市金丰玩具有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=3990b949d481095d57ce2aaff6412842",
      //     classificationOne: "设备制造",
      //     classificationTwo: "儿童玩具",
      //     classificationThree: "儿童玩具"
      //   },
      //   {
      //     img: "static/images/67.png",
      //     name: "广州妮希雅服装有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=f494806a8b8df46743c6ce51808c1a75",
      //     classificationOne: "纺织制衣",
      //     classificationTwo: "服装",
      //     classificationThree: "服装"
      //   },
      //   {
      //     img: "static/images/68.png",
      //     name: "任丘市华福盛通讯器材有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9c245c8ffa22e3a6be6d6c7d33da6b68",
      //     classificationOne: "设备制造",
      //     classificationTwo: "天线",
      //     classificationThree: "天线"
      //   },
      //   {
      //     img: "static/images/69.png",
      //     name: "新乐华宝医疗用品有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=8a2fee51e8ac23a1db6218a386839db6",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "医疗器械 ",
      //     classificationThree: "医疗器械"
      //   },
      //   {
      //     img: "static/images/70.png",
      //     name: "上海裕生特种线材",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=b459c7176891a2d28511813df7ed4edc",
      //     classificationOne: "设备制造",
      //     classificationTwo: "特种线材",
      //     classificationThree: "特种线材"
      //   },
      //   {
      //     img: "static/images/71.png",
      //     name: "宁波金盾电子工业股份有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=26ac35917159e2086a1ca1008126795a",
      //     classificationOne: "设备制造",
      //     classificationTwo: "报警器",
      //     classificationThree: "报警器"
      //   },
      //   {
      //     img: "static/images/72.png",
      //     name: "安徽红树林新材料科技有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=99a3096a45be0f60db87a5074ee61a42",
      //     classificationOne: "设备制造",
      //     classificationTwo: "塑木材料",
      //     classificationThree: "塑木材料"
      //   },
      //   {
      //     img: "static/images/73.png",
      //     name: "醴陵市瑞祥瓷业有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=2e1cc40153cd6649da6caf9eb19b259c",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "瓷器",
      //     classificationThree: "瓷器"
      //   },
      //   {
      //     img: "static/images/74.png",
      //     name: "宁波招宝山旅游风景区",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=761ea95a7a2db0072227281e51245f91",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/75.png",
      //     name: "汕头市优品教育咨询有限公司 ",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=0742c09e7672d84d654dc3c5e8feb672",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "幼儿园",
      //     classificationThree: "幼儿园"
      //   },
      //   {
      //     img: "static/images/76.png",
      //     name: "海宁爱生太阳能科技有限公司 ",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=9f7c4846b6f3d45a658215edb28aa775",
      //     classificationOne: "设备制造",
      //     classificationTwo: "太阳能",
      //     classificationThree: "太阳能"
      //   },
      //   {
      //     img: "static/images/77.png",
      //     name: "2018华为北展联通大客户专场 ",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/tour/project/71434cddcad1cc7d/?from=singlemessage&isappinstalled=0",
      //     classificationOne: "其它",
      //     classificationTwo: "展会展厅",
      //     classificationThree: "展厅"
      //   },
      //   {
      //     img: "static/images/78.png",
      //     name: "金昌市文化博览馆 ",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/5f621cdbea335da6/",
      //     classificationOne: "其它",
      //     classificationTwo: "博物馆",
      //     classificationThree: "博物馆"
      //   },
      //   {
      //     img: "static/images/79.png",
      //     name: "成都展会",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=be64591ae61c047aff5782d2a0ed79c4",
      //     classificationOne: "其它",
      //     classificationTwo: "展会展厅",
      //     classificationThree: "展厅"
      //   },

      //   {
      //     img: "static/images/80.png",
      //     name: "中智合肥产业园管理有限公司",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=63eb1808775f39faeafd201c8ca87835",
      //     classificationOne: "其它",
      //     classificationTwo: "展会展厅",
      //     classificationThree: "展厅"
      //   },
      //   {
      //     img: "static/images/81.png",
      //     name: "安徽尊贵电器集团有限公司",
      //     flag: "true",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=17632075e71ee238649bc1d9118ae7d1",
      //     classificationOne: "设备制造",
      //     classificationTwo: "电器制造",
      //     classificationThree: "电器制造"
      //   },
      //   {
      //     img: "static/images/82.png",
      //     name: "三里屯home皇后饼屋",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=d9102a424056c3cbb8ba1c04f2d83528",
      //     classificationOne: "其它",
      //     classificationTwo: "餐饮娱乐",
      //     classificationThree: "餐饮娱乐"
      //   },
      //   {
      //     img: "static/images/83.png",
      //     name: "东大街VR全景",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/3a3b76716a47bc2e/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "幼儿园"
      //   },
      //   {
      //     img: "static/images/84.png",
      //     name: "好声音KTV",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/25f0b62b06f82319/",
      //     classificationOne: "其它",
      //     classificationTwo: " 餐饮娱乐",
      //     classificationThree: " 餐饮娱乐"
      //   },
      //   {
      //     img: "static/images/85.png",
      //     name: "厦门大学VR全景",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/a3063c31e07e4a94/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/86.png",
      //     name: "北京励骏酒店",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/e9b9ffdef800a4df/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/87.png",
      //     name: "瑞海姆田园度假村",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/310b967cc7b5ef77/",
      //     classificationOne: "其它",
      //     classificationTwo: "民宿",
      //     classificationThree: "民宿"
      //   },
      //   {
      //     img: "static/images/88.png",
      //     name: "上海工程技术学院",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/28b8dd5b1672fbd9/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/89.png",
      //     name: "华东政法大学",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/4488e2fc8f3c07da/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/90.png",
      //     name: "上海交通大学VR全景展示",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b53fe102efcb2bff/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/91.png",
      //     name: "清华大学美术学院",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/f730b1a4035c877b/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/92.png",
      //     name: "华南理工大学",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/e8de9e52f02ea0ed/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/93.png",
      //     name: "中国政法大学",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/fd8876378762d688/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "高校"
      //   },
      //   {
      //     img: "static/images/94.png",
      //     name: "定州生态园VR全景展示",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b8a718d372bebbfb/",
      //     classificationOne: "其它",
      //     classificationTwo: "民宿",
      //     classificationThree: "民宿"
      //   },
      //   {
      //     img: "static/images/95.png",
      //     name: "北京万寿公园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/032d228f15602d2a/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/96.png",
      //     name: "醉美六安",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/7964c660a1abbce3/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/97.png",
      //     name: "福禄贝尔婚纱摄影",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/5b9d3b37539a3e84/",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "瓷器家居",
      //     classificationThree: "瓷器家居"
      //   },
      //   {
      //     img: "static/images/98.png",
      //     name: "北京丽景幼儿园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/94c49e616a86eeef/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "学校教育",
      //     classificationThree: "幼儿园"
      //   },
      //   {
      //     img: "static/images/99.png",
      //     name: "康乐金鑫饭店",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/24f4f3d7ccc8e60d/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/100.png",
      //     name: "安徽花亭湖",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/c00e2525f0a0a948/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/101.png",
      //     name: "安徽定远城市全景",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/dfa4d7ae59af6988/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/102.png",
      //     name: "合肥野生动物园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/6e11af8cd574b1be/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/103.png",
      //     name: "福建丹桂之乡",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/17ff3af13a9efc44/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/104.png",
      //     name: "皖西博物馆",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/aae431ab0f87f80e/",
      //     classificationOne: "其它",
      //     classificationTwo: "博物馆",
      //     classificationThree: "博物馆"
      //   },
      //   {
      //     img: "static/images/105.png",
      //     name: "安徽详源太湖",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/1e18f55b945f2b3d/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/106.png",
      //     name: "蒲城科技园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/ea9d9c7da2738ded/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/107.png",
      //     name: "平潭金永雅阁度假酒店",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/8a7e71279bb1faab/",
      //     classificationOne: "娱乐休闲",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/108.png",
      //     name: "泉州少林寺VR全景",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/c9a6854afa97f3d5/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/109.png",
      //     name: "嘉都VR全景看房",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/0a12582ce9480994/",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "地产",
      //     classificationThree: "地产"
      //   },
      //   {
      //     img: "static/images/110.png",
      //     name: "开元寺",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b80e0959058a58b8/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },

      //   {
      //     img: "static/images/111.png",
      //     name: "海阳旅游风景区",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/d920dac68f4ca869/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/112.png",
      //     name: "江门城市展示",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/73bb9bb2fe0224d9/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/113.png",
      //     name: "清泉古寺",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/052097753069a03e/",
      //     classificationOne: "其它",
      //     classificationTwo: " 机构园区",
      //     classificationThree: " 机构园区"
      //   },
      //   {
      //     img: "static/images/114.png",
      //     name: "西湖公园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/6acfa576e78a29c2/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/115.png",
      //     name: "东华禅寺",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/f3741f6aaa0d9ea8/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/116.png",
      //     name: "贵州传统村落",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/be335888fadb1313/",
      //     classificationOne: "其它",
      //     classificationTwo: "民宿",
      //     classificationThree: "民宿"
      //   },
      //   {
      //     img: "static/images/117.png",
      //     name: "广西丹泉洞天酒海",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/1261840df1b033c6/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒业",
      //     classificationThree: "酒业"
      //   },
      //   {
      //     img: "static/images/118.png",
      //     name: "黎平县文化旅游景区",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b44fe898498e9001/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/119.png",
      //     name: "天津生态城世茂希尔顿酒店",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/2a47d33f71b1eeac/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/120.png",
      //     name: "北京汇诚鑫达汽车销售有限公司",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/9b8afec411c09ba1/",
      //     classificationOne: "其它",
      //     classificationTwo: "汽车服务",
      //     classificationThree: "汽车服务"
      //   },
      //   {
      //     img: "static/images/121.png",
      //     name: "福建福鼎市茶园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/416ec683c2b17e97/",
      //     classificationOne: "其它",
      //     classificationTwo: "餐饮娱乐",
      //     classificationThree: "餐饮娱乐"
      //   },
      //   {
      //     img: "static/images/122.png",
      //     name: "金童子温泉度假村",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/5085c4fe08ab3c2c/",
      //     classificationOne: "其它",
      //     classificationTwo: "民宿",
      //     classificationThree: "民宿"
      //   },
      //   {
      //     img: "static/images/123.png",
      //     name: "湖南梨树园涂料",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b7cbf9e306ad2406/",
      //     classificationOne: "矿业加工",
      //     classificationTwo: "涂料",
      //     classificationThree: "涂料"
      //   },
      //   {
      //     img: "static/images/124.png",
      //     name: "嘉德丽形象提升中心",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/3cc92b936d0b0005/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/125.png",
      //     name: "国际教育展览会",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/eca0a5e0c6aa0d1d/",
      //     classificationOne: "其它",
      //     classificationTwo: "展会展厅",
      //     classificationThree: "线上会展"
      //   },
      //   {
      //     img: "static/images/126.png",
      //     name: "北京电子城IT产业园",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b5f5bd6f11d77768/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },

      //   {
      //     img: "static/images/127.png",
      //     name: "庆星酒店",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/3b7162895077917a/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/128.png",
      //     name: "张坊古镇",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/9dcbbd5fe32219b3/",
      //     classificationOne: "旅游景区",
      //     classificationTwo: "旅游景区",
      //     classificationThree: "旅游景区"
      //   },
      //   {
      //     img: "static/images/129.png",
      //     name: "万达瑞华",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/13a674142646b81d/",
      //     classificationOne: "其它",
      //     classificationTwo: "酒店",
      //     classificationThree: "酒店"
      //   },
      //   {
      //     img: "static/images/130.png",
      //     name: "聚焦BAB儿童摄影",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/b8a2ec5415b24e62/",
      //     classificationOne: "其它",
      //     classificationTwo: "机构园区",
      //     classificationThree: "机构园区"
      //   },
      //   {
      //     img: "static/images/131.png",
      //     name: "航天健康管理部",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/8c4f1a3487bb8987/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "医院",
      //     classificationThree: "医院"
      //   },
      //   {
      //     img: "static/images/132.png",
      //     name: "库比家居",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/11321167d3f2f6c3/",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "家居广场",
      //     classificationThree: "家居广场"
      //   },
      //   {
      //     img: "static/images/133.png",
      //     name: "福乐瓷砖",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/fd729dcfdbcbddf5/",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "装饰装潢",
      //     classificationThree: "装饰装潢"
      //   },
      //   {
      //     img: "static/images/134.png",
      //     name: "宝马汽车",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/172b77f518c5997d/",
      //     classificationOne: "其它",
      //     classificationTwo: "其它",
      //     classificationThree: "汽车服务"
      //   },
      //   {
      //     img: "static/images/135.png",
      //     name: "中国美术学院师生展",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/834f11bff2dca55f/",
      //     classificationOne: "其它",
      //     classificationTwo: "展会展厅",
      //     classificationThree: "美术馆"
      //   },
      //   {
      //     img: "static/images/136.png",
      //     name: "诺禾致源科技服务实验室",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/663d7e4db5d3d9b3/",
      //     classificationOne: "其它",
      //     classificationTwo: " 机构园区",
      //     classificationThree: " 机构园区"
      //   },
      //   {
      //     img: "static/images/137.png",
      //     name: "三生（中国）健康产业园VR",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/fe6c675dbf53004f/",
      //     classificationOne: "教育医疗",
      //     classificationTwo: "生物制药",
      //     classificationThree: "生物制药"
      //   },
      //   {
      //     img: "static/images/138.png",
      //     name: "皓顺一号院",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=a5084b314e692089d7f23cba008f0a50",
      //     classificationOne: "瓷器家居",
      //     classificationTwo: "房地产",
      //     classificationThree: "房地产"
      //   },
      //   {
      //     img: "static/images/139.png",
      //     name: "魅KTV",
      //     flag: "false",
      //     url:
      //       "https://www.yunjing720.com/index.php?s=tour/index/index&tid=88a6ee94620dfbe155a4b492a29fbfed",
      //     classificationOne: "其它",
      //     classificationTwo: "餐饮娱乐",
      //     classificationThree: "餐饮娱乐"
      //   },
      //   {
      //     img: "static/images/140.png",
      //     name: "百汇地动漫谷水世界",
      //     flag: "false",
      //     url: "https://www.yunjing720.com/tour/project/899a9084e3ae1869/",
      //     classificationOne: "其它",
      //     classificationTwo: "商超",
      //     classificationThree: "商超"
      //   }
      // ],
      footer: [
        {
          img: "static/image/d1.png",
          name: "专业团队",
          title: "深耕多年，经验丰富"
        },
        {
          img: "static/image/d2.png",
          name: "上门拍摄",
          title: "面对面洽谈，沟通便捷"
        },
        {
          img: "static/image/d3.png",
          name: "功能组件",
          title: "智能门户，深度交互"
        },
        {
          img: "static/image/d4.png",
          name: "服务保障",
          title: "全程质控，安全交付"
        }
      ],
      objList: [],
      page: 1,
      pageSize: 10,
      loadMore: true,
      current: "全部"
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.list.forEach(item => {
      if (this.objList.length < this.pageSize) {
        this.objList.push(item);
      }
    });
    if (this.objList.length < 10) {
      this.loadMore = false;
    }
  },
  beforeDestroy() {},
  destroyed() {},
  methods: {
    clickTap(val) {
      this.page = 1;
      this.current = val;
      this.listArray();
    },
    loadMores() {
      this.page = this.page + 1;
      this.listArray();
    },
    listArray() {
      this.objList = [];

      this.list.forEach(item => {
        if (item.classificationOne === this.current) {
          if (this.objList.length < this.pageSize * this.page) {
            this.objList.push(item);
          }
        } else if ("全部" === this.current) {
          if (this.objList.length < this.pageSize * this.page) {
            this.objList.push(item);
          }
        }
      });
      if (this.objList.length < this.pageSize * this.page) {
        this.loadMore = false;
      } else {
        this.loadMore = true;
      }
    }
  },
  components: {
    footerS,
    List
  }
};
</script>

<style lang='less' scoped>
.hello {
  .divBox {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: none;
    align-items: center;
  }
  header {
    width: 100%;
    > img {
      width: 100%;
    }
  }
  section {
    > .select {
      margin: 36px 0;
      > div {
        display: flex;
        justify-content: space-between;
        padding: 0 34px;
        > img {
          display: flex;
          width: 104px;
          height: 145px;
          cursor: pointer;
        }
      }
      > div:nth-child(1) {
        padding-bottom: 32px;
      }
    }
    > p {
      display: flex;
      justify-content: center;
      margin: 30px 0 0;
      font-size: 24px;
      color: #999;
      cursor: pointer;
    }
  }
  footer {
    width: 100%;
    margin-top: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue